export const SeguroTabs = {
  'seguro-santander-auto': {
    id: 0,
    href: 'seguro-santander-auto',
    label: 'Seguro Auto',
    navigate: true,
    t: '',
  },
  'cdc-protegido': {
    id: 1,
    href: 'cdc-protegido',
    label: 'Seguro Proteção Financeira',
    navigate: true,
    t: '',
  },
  'mao-na-roda': {
    id: 2,
    href: 'mao-na-roda',
    label: 'Mão na Roda',
    navigate: true,
    t: '',
  },
};
